(function (window) {
    if ($('[data-control="location-dropdown"]').length <= 0) {
        return;
    };

    let locationDropdown = $('[data-control="location-dropdown"]');
    let locationList = $('[data-region="locationlist"]');

    locationDropdown.on('change', function (e) {
        let locateId = locationDropdown.val();
        console.log(locationList.find('.-active'));
        locationList.find('.-active').removeClass('-active');
        locationList.find('[data-id="' + locateId + '"]').addClass('-active');
    });

})(window);
